import React from "react";

// MATERIAL UI
import Chip from "@mui/material/Chip";
import Popper from "@mui/material/Popper";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { LightGreyBox } from "../../styled";
import {
  cfopFrame,
  cofins_situacao_tributaria_frame,
  icms_origem_frame,
  icms_situacao_tributaria_frame,
  pis_situacao_tributaria_frame,
} from "../../../common/frames";
import PercentageInput from "../../Inputs/percentageInput";
import DebouncedAutocomplete from "../../Inputs/DebouncedAutocomplete";
import { getProducts } from "../../../api/product";

const ItemFiscalDataForm = ({
  cfopCode,
  setCfopCode,
  icmsSituacaoTributariaState,
  setIcmsSituacaoTributariaState,
  icmsOrigemState,
  setIcmsOrigemState,
  icmsValue,
  setIcmsValue,
  pisSituacaoTributariaState,
  setPisSituacaoTributariaState,
  pisValue,
  setPisValue,
  cofinsSituacaoTributariaState,
  setCofinsSituacaoTributariaState,
  cofinsValue,
  setCofinsValue,
  fiscalCode,
  setFiscalCode,
  ifoodExternalCode,
  setIfoodExternalCode,
  isDefaultItemConfig = false,
}) => {
  const setFiscalStates = (item) => {
    const {
      cfop,
      icms_situacao_tributaria,
      pis_situacao_tributaria,
      cofins_situacao_tributaria,
      icms_origem,
      icms_aliquota,
      pis_aliquota,
      cofins_aliquota,
      fiscal_code,
    } = item;

    if (fiscal_code) {
      setFiscalCode(fiscal_code);
    }

    if (cfop) {
      const foundCfop = cfopFrame.find((frameItem) => frameItem.value === cfop);
      setCfopCode(foundCfop ?? cfopFrame[0]);
    }

    if (icms_situacao_tributaria) {
      const foundIcmsSituacaoTributaria = icms_situacao_tributaria_frame.find(
        (frameItem) => frameItem.value === icms_situacao_tributaria
      );
      setIcmsSituacaoTributariaState(
        foundIcmsSituacaoTributaria ?? icms_situacao_tributaria_frame[0]
      );
    }

    if (icms_origem) {
      const foundIcmsOrigem = icms_origem_frame.find(
        (frameItem) => frameItem.value === icms_origem
      );
      setIcmsOrigemState(foundIcmsOrigem ?? icms_origem_frame[0]);
    }

    if (icms_aliquota) {
      setIcmsValue(icms_aliquota);
    }

    if (pis_situacao_tributaria) {
      const foundPisSituacaoTributaria = pis_situacao_tributaria_frame.find(
        (frameItem) => frameItem.value === pis_situacao_tributaria
      );
      setPisSituacaoTributariaState(
        foundPisSituacaoTributaria ?? pis_situacao_tributaria_frame[0]
      );
    }

    if (pis_aliquota) {
      setPisValue(pis_aliquota);
    }

    if (cofins_situacao_tributaria) {
      const foundCofinsSituacaoTributaria =
        cofins_situacao_tributaria_frame.find(
          (frameItem) => frameItem.value === cofins_situacao_tributaria
        );
      setCofinsSituacaoTributariaState(
        foundCofinsSituacaoTributaria ?? cofins_situacao_tributaria_frame[0]
      );
    }

    if (cofins_aliquota) {
      setCofinsValue(cofins_aliquota);
    }
  };

  const fetchItemsToCopyFiscalData = async (query) => {
    try {
      const params = {
        title: query,
      };
      const { data } = await getProducts(params);
      return data;
    } catch (e) {}
  };

  return (
    <LightGreyBox>
      <DebouncedAutocomplete
        label={"Copiar dados de outro produto"}
        fetchOptions={fetchItemsToCopyFiscalData}
        getOptionLabel={(option) => option.title}
        getOptionValue={(option) => option}
        onSelect={setFiscalStates}
      />

      <Divider sx={{ mb: 2 }}>
        <Chip label="ICMS" />
      </Divider>

      <PercentageInput
        label="Aliquota ICMS em %"
        fullWidth
        value={icmsValue}
        onChange={setIcmsValue}
      />

      <Autocomplete
        size="small"
        fullWidth
        value={cfopCode}
        onChange={(event, newValue) => {
          setCfopCode(newValue);
        }}
        options={cfopFrame}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => (
          <TextField {...params} label="CFOP" variant="outlined" />
        )}
        PopperComponent={(props) => (
          <Popper {...props} style={{ zIndex: 9999 }} />
        )}
        sx={{ my: 2 }}
      />

      <Autocomplete
        size="small"
        fullWidth
        value={icmsSituacaoTributariaState}
        onChange={(event, newValue) => {
          setIcmsSituacaoTributariaState(newValue);
        }}
        options={icms_situacao_tributaria_frame}
        getOptionLabel={(option) => `${option.value} - ${option.label}`}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Situação Tributária ICMS"
            variant="outlined"
          />
        )}
        PopperComponent={(props) => (
          <Popper {...props} style={{ zIndex: 9999 }} />
        )}
        sx={{ my: 2 }}
      />

      <Autocomplete
        size="small"
        fullWidth
        value={icmsOrigemState}
        onChange={(event, newValue) => {
          setIcmsOrigemState(newValue);
        }}
        options={icms_origem_frame}
        getOptionLabel={(option) => `${option.value} - ${option.label}`}
        renderInput={(params) => (
          <TextField {...params} label="Origem" variant="outlined" />
        )}
        PopperComponent={(props) => (
          <Popper {...props} style={{ zIndex: 9999 }} />
        )}
        sx={{ my: 2 }}
      />

      <Divider sx={{ mb: 2 }}>
        <Chip label="PIS/ COFINS" />
      </Divider>

      <PercentageInput
        label="Aliquota PIS em %"
        fullWidth
        value={pisValue}
        onChange={setPisValue}
      />

      <Autocomplete
        size="small"
        fullWidth
        value={pisSituacaoTributariaState}
        onChange={(event, newValue) => {
          setPisSituacaoTributariaState(newValue);
        }}
        options={pis_situacao_tributaria_frame}
        getOptionLabel={(option) => `${option.value} - ${option.label}`}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Sit. Tributária PIS"
            variant="outlined"
          />
        )}
        PopperComponent={(props) => (
          <Popper {...props} style={{ zIndex: 9999 }} />
        )}
        sx={{ my: 2 }}
      />

      <PercentageInput
        label="Aliquota COFINS em %"
        fullWidth
        value={cofinsValue}
        onChange={setCofinsValue}
      />

      <Autocomplete
        size="small"
        fullWidth
        value={cofinsSituacaoTributariaState}
        onChange={(event, newValue) => {
          setCofinsSituacaoTributariaState(newValue);
        }}
        options={cofins_situacao_tributaria_frame}
        getOptionLabel={(option) => `${option.value} - ${option.label}`}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Sit. Tributária COFINS"
            variant="outlined"
          />
        )}
        PopperComponent={(props) => (
          <Popper {...props} style={{ zIndex: 9999 }} />
        )}
        sx={{ my: 2 }}
      />

      <Divider>
        <Chip label="NCM" />
      </Divider>

      <TextField
        size="small"
        variant="outlined"
        id="new_product_fiscal_code"
        name="fiscal_code"
        label="Código NCM"
        fullWidth
        value={fiscalCode}
        onChange={(event) => {
          setFiscalCode(event.target.value);
        }}
        sx={{ my: 2 }}
      />

      {!isDefaultItemConfig && (
        <>
          <Divider>
            <Chip label="CÓDIGO PDV IFOOD" />
          </Divider>

          <TextField
            size="small"
            variant="outlined"
            id="new_product_ifood_pos_code"
            name="ifood_pos_code"
            label="Código PDV Ifood"
            fullWidth
            value={ifoodExternalCode}
            onChange={(event) => {
              setIfoodExternalCode(event.target.value);
            }}
            sx={{ my: 2 }}
          />
        </>
      )}
    </LightGreyBox>
  );
};

export default ItemFiscalDataForm;
